import { render } from "./FollowUpNotesUpdateOverlay.vue?vue&type=template&id=1b9fc8dc&scoped=true&lang=pug"
import script from "./FollowUpNotesUpdateOverlay.vue?vue&type=script&lang=js"
export * from "./FollowUpNotesUpdateOverlay.vue?vue&type=script&lang=js"

import "./FollowUpNotesUpdateOverlay.vue?vue&type=style&index=0&id=1b9fc8dc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9fc8dc"]])

export default __exports__